// extracted by mini-css-extract-plugin
module.exports = {"start":"course_start__5gMEk","slide":"course_slide__DIc_N","octopussy":"course_octopussy____21W"};